import { Box, Flex } from '@chakra-ui/react';

import { MeshMavenWithYellowBackground } from 'assets/assetsV1/iconComponents/MeshMavenWithYellowBackground';

import { BottomDrawer, DrawerContent, DrawerHeader, primaryDrawerWidth, DrawerFooter } from 'uiToolkitV1/BottomDrawer';
import { Button } from 'uiToolkitV1/Button';
import { TextBodyMedium, TextLabel, TextHeader4 } from 'uiToolkitV1/Typography';

const SuggestionReasonCard = ({ suggestionType, suggestionBody }) => {
  const Icon = MeshMavenWithYellowBackground;
  const title = suggestionType === 'maven' ? 'Maven recommends this because' : 'Based on people science principles';
  return (
    <Box
      p="8px 8px 12px 8px"
      mt="8px"
      gap="8px"
      borderRadius="8px"
      border="1px solid #EBEFF3"
      background="var(--meshai-mesh-aibg-2, linear-gradient(90deg, rgba(0, 142, 240, 0.02) 1.83%, rgba(236, 59, 100, 0.02) 34.86%, rgba(255, 194, 0, 0.02) 65.54%, rgba(92, 196, 97, 0.02) 100%))"
    >
      <Box>
        <Flex alignItems="center">
          <Icon boxSize="32px" mr="4px" ml="4px" />
          <TextHeader4 bold>{title}</TextHeader4>
        </Flex>
        <Box
          p="8px"
          mt="8px"
          borderRadius="8px"
          border="1px solid var(--Light-Card-Transition-Shade, #F5F7F9)"
          bg="white"
        >
          <TextBodyMedium>{suggestionBody}</TextBodyMedium>
        </Box>
      </Box>
    </Box>
  );
};

const ExplainWhyBottomSheet = ({ onClose, revieweeName, actionItem }) => {
  const { explanation, peopleSciencePrinciple, actionItemText, isMlGenerated } = actionItem;
  if (!isMlGenerated) return null;

  return (
    <BottomDrawer isOpen onClose={onClose}>
      <DrawerContent width={`${primaryDrawerWidth}px`}>
        <DrawerHeader onClose={onClose}>{undefined}</DrawerHeader>
        <Flex borderRadius="8px" h="100%" bg="white" p="4px">
          <Flex
            flexDir="column"
            justifyContent="space-between"
            borderRadius="8px"
            bg="#CFD7DF"
            h="100%"
            width="100%"
            p="4px"
          >
            <Box
              flexDir="column"
              alignItems="flex-start"
              alignSelf="stretch"
              borderRadius="8px 8px 0 0"
              bg="white"
              h="100%"
              width="100%"
              p="8px 12px"
              gap="8px"
            >
              <Box borderRadius="8px 8px 0 0">
                <Flex alignItems="center">
                  <MeshMavenWithYellowBackground boxSize="14px" mr="4px" ml="4px" />
                  <TextLabel color="text.g2">Maven recommended action plan for {revieweeName}</TextLabel>
                </Flex>
                <Box p="4px 8px 12px 8px" borderBottom="1px solid #CFD7DF">
                  <TextHeader4 bold noOfLines={2}>
                    {actionItemText}
                  </TextHeader4>
                </Box>
              </Box>
              <SuggestionReasonCard suggestionType="maven" suggestionBody={explanation} />
              <SuggestionReasonCard suggestionType="peopleScience" suggestionBody={peopleSciencePrinciple} />
            </Box>
            <Box borderRadius="0 0 8px 8px" overflow="hidden">
              <DrawerFooter backgroundColor="#EBEFF3">
                <Button variant="filled" colorScheme="blue" onClick={onClose} disabled={false}>
                  Close
                </Button>
              </DrawerFooter>
            </Box>
          </Flex>
        </Flex>
      </DrawerContent>
    </BottomDrawer>
  );
};

export default ExplainWhyBottomSheet;
